import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPlayCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.45455C4.38505 1.45455 1.45455 4.38505 1.45455 8C1.45455 11.615 4.38505 14.5455 8 14.5455C11.615 14.5455 14.5455 11.615 14.5455 8C14.5455 4.38505 11.615 1.45455 8 1.45455ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM6.20229 4.44969C6.43876 4.32313 6.7257 4.337 6.94887 4.48578L11.3125 7.39487C11.5148 7.52976 11.6364 7.75683 11.6364 8C11.6364 8.24317 11.5148 8.47024 11.3125 8.60513L6.94887 11.5142C6.7257 11.663 6.43876 11.6769 6.20229 11.5503C5.96581 11.4237 5.81818 11.1773 5.81818 10.9091V5.09091C5.81818 4.82269 5.96581 4.57625 6.20229 4.44969ZM7.27273 6.44983V9.55017L9.59798 8L7.27273 6.44983Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPlayCircle)
const IconSvgPlayCircle = createIcon(ForwardRef, 'SvgPlayCircle')
export default IconSvgPlayCircle
